export enum MeetingStatus {
    INPROGRESS = 'INPROGRESS',
    ENDED = 'ENDED',
    PAYMENT = 'PAYMENTDUE'
}